import type {ChipId} from './config';

/** Reserve stock so every remaining scene can offer a new tool. */
export function drawStageOffers(available: readonly ChipId[], remainingScenes: number, random:()=>number=Math.random): ChipId[] {
  const pool=[...available];
  const count=Math.min(3,Math.max(pool.length>0?1:0,pool.length-Math.max(0,remainingScenes)));
  const offers:ChipId[]=[];
  while(pool.length&&offers.length<count){
    const index=Math.min(pool.length-1,Math.max(0,Math.floor(random()*pool.length)));
    offers.push(pool.splice(index,1)[0]);
  }
  return offers;
}
